 let questionsmenu = document.querySelectorAll(".questionsmenu");
  questionsmenu.forEach(questionsmenu => {
    questionsmenu.addEventListener("click", event => {
      const active = document.querySelector(".questionsmenu.active");
      if (active && active !== questionsmenu) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      questionsmenu.classList.toggle("active");
      const answersmenu = questionsmenu.nextElementSibling;
      if (questionsmenu.classList.contains("active")) {
        answersmenu.style.maxHeight = answersmenu.scrollHeight + "px";
      } else {
        answersmenu.style.maxHeight = 0;
      }
    })
  })